import Dialog from '@mui/material/Dialog';
import React from 'react';
import { Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, AppBar, Toolbar } from '@mui/material'
import Slide from '@mui/material/Slide';
import { forwardRef, Fragment, useEffect, useRef, useState } from 'react';
import { DOMAIN } from '../../config';
import CustomizedProgressBars from '../common/loading';
import { getRandom } from '../../funcs';
import SearchDialog from '.';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';


const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

export default function BlogerDialog({openBloger,setOpenBloger,matches}) {
  const [latest,setLatest] = useState(null)
  const dialogRef = useRef(null)
  const [loading,setLoading] = useState(true)
  const [chipTitle, setChipTitle] = useState(null)
  const [openSearch, setOpenSearch] = useState(false)
  const touchStartRef = useRef(0);

  const handleSwipe = (event) => {
    const touchEndX = event.changedTouches[0].clientX;
    const swipeDistance = touchStartRef.current - touchEndX;

    if (swipeDistance > 120) { // 设定滑动距离阈值
        setOpenBloger(false);
    }
  };

  const handleTouchStart = (event) => {
    touchStartRef.current = event.touches[0].clientX;
  };



  const handleClose = () => {
    setOpenBloger(false);
  };

  const handleOpenSearch = (text)=>{
    setChipTitle(text)
    setOpenSearch(true)
  }

  const TimestampConverter = (timestamp) => {
    const date = new Date(timestamp*1000);
    const dateString = date.toLocaleDateString(); // 获取日期字符串
    return dateString
  };


  useEffect(()=>{
    if(!openBloger) return
    fetch(`${DOMAIN}ywyminiappbot/getbloger`)
    .then((response)=>response.json())
    .then((data)=>{
        setLatest(data)
        setLoading(false)
    })
  },[openBloger])


  return (
    <Fragment >
      <SearchDialog 
                openSearch={openSearch} 
                setOpenSearch={setOpenSearch} 
                matches={matches}
                chipTitle={chipTitle}
                isRemark={false}
            />
      <Dialog 
        fullScreen
        open={openBloger}
        onClose={handleClose}
        TransitionComponent={Transition}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleSwipe}
        PaperProps={{
          onTouchStart: handleTouchStart,
          onTouchEnd: handleSwipe,
        }}
      >
        <AppBar sx={{ position: 'sticky' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              热门博主
            </Typography>
          </Toolbar>
        </AppBar>
        {loading&&<CustomizedProgressBars/>}
        {
         latest&& <Container style={{ marginTop: '20px' }}>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>博主</TableCell>
                            <TableCell align="right">视频数量</TableCell>
                            <TableCell align="right">最近更新</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {latest.map((row) => (
                            <TableRow key={row.latest_date+getRandom()} onClick={()=>{
                              handleOpenSearch(row.title)
                            }}>
                                <TableCell component="th" scope="row">
                                    {row.title}
                                </TableCell>
                                <TableCell align="right">{row.caption_count}</TableCell>
                                <TableCell align="right">{TimestampConverter(row.latest_date)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
        }
        
      </Dialog>
    </Fragment>
  );
}